module.exports = __webpack_public_path__ + "static/media/galerija_2019 (36).0fdf2dd7.jpg";